import { render, staticRenderFns } from "./Roadway.vue?vue&type=template&id=73aedf08&"
import script from "./Roadway.vue?vue&type=script&lang=js&"
export * from "./Roadway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports